module.exports = __webpack_public_path__ + "img/w2.4c9695f0.png";